module.exports = __webpack_public_path__ + "img/CM-CA-111722-Ford-LifeStyle.f51b4a85.jpg";